module.exports = __webpack_public_path__ + "static/media/escape-signature.3f804ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/escape-signature.png
// module id = 335
// module chunks = 0